/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_EyebrowInputs */

const tr_landing_community_eyebrow = /** @type {(inputs: Landing_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`topluluk + destek`)
};

const en_landing_community_eyebrow = /** @type {(inputs: Landing_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`community + support`)
};

const de_landing_community_eyebrow = /** @type {(inputs: Landing_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community + Support`)
};

const ru_landing_community_eyebrow = /** @type {(inputs: Landing_Community_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`сообщество + поддержка`)
};

/**
* | output |
* | --- |
* | "community + support" |
*
* @param {Landing_Community_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_eyebrow = /** @type {((inputs?: Landing_Community_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_eyebrow(inputs)
	if (locale === "de") return de_landing_community_eyebrow(inputs)
	if (locale === "ru") return ru_landing_community_eyebrow(inputs)
	return tr_landing_community_eyebrow(inputs)
});